import ServiceCRUD from '../../../../services/ServiceGasOrder';

class AccountService extends ServiceCRUD {
  constructor() {
    super(`/api/contas`);
  }
}

export default new AccountService();
